import SSDPHelp from './ssdp/ssdpHelp.js'
import Vue from 'vue'
import Base64 from './base64.js'
import { Modal } from 'ant-design-vue'
import store from '../store/index'
class Request {
  constructor() {
    this.ready = false
    this.init().catch(e => {
      this.error = e
    })
  }
  post({
    api,
    version,
    apiAuthType = process.env.NODE_ENV === 'development' ? '0' : '2',
    signType = '0',
    shouldEncryptParam = false,
    params
  }) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`======发起接口请求:${api}======`)
      return this.SSDPHelp.request({
        api,
        version,
        params
      })
    } else {
      console.log(process.env.NODE_ENV)
      console.log('接口请求参数')
      console.log({
        apiId: api,
        apiVersion: version,
        apiAuthType,
        signType,
        shouldEncryptParam,
        biz: params
      })
      return new Promise((resolve, reject) => {
        let isIos = !navigator.userAgent.match(/android/i)
        console.log(`======发起接口请求:${api}======`)
        store.commit('setloading', true) //在请求发出之前进行一些操作
        crh.ssdpCallPost({
          param: {
            apiId: api,
            apiVersion: version,
            apiAuthType,
            signType,
            shouldEncryptParam,
            biz: params
          },
          success: res => {
            console.log(`======接口成功返回:======`)
            store.commit('setloading', false)
            console.warn('是否响应', res, isIos)
            // ios和安卓的数据返回不一样，这里做个统一处理
            if (!isIos)
              res.RESPONSE.RETURN_DATA = JSON.parse(res.RESPONSE.RETURN_DATA)
            let { RETURN_CODE, RETURN_DESC, RETURN_DATA } = res.RESPONSE
            if (!['S000A000', 'S0A00000', 'S1A00000'].includes(RETURN_CODE)) {
              // new Vue.prototype.$Dialog({
              //   title: "温馨提示",
              //   text: RETURN_DATA.RETURN_DESC || RETURN_DESC
              // });
              Modal.error({
                title: '温馨提示',
                content: RETURN_DATA.RETURN_DESC || RETURN_DESC
              })
              reject(RETURN_DESC)
            } else {
              resolve(res.RESPONSE)
            }
          },
          fail: err => {
            console.log(`======接口失败返回:======`)
            store.commit('setloading', false)
            console.log('1', err)
            crh.getNetworkType({
              success: res => {
                if (res.networkType == 'none') {
                  // new Vue.prototype.$Dialog({
                  //   title: '温馨提示',
                  //   text: '网络异常',
                  //   onOk() {
                  //     crh.closeWebApp();
                  //     return
                  //   },
                  //   theme: 'ios',
                  //   confirm: false
                  // })
                  Modal.error({
                    title: '温馨提示',
                    content: '网络异常',
                    onOk() {
                      crh.closeWebApp()
                      return
                    }
                  })
                } else {
                  let { returnDesc, returnData } = err
                  console.log('2', returnData)
                  returnData = JSON.parse(Base64.decode(returnData))
                  console.log('3', returnData)
                  let {
                    RETURN_DATA,
                    RETURN_CODE,
                    RETURN_DESC
                  } = returnData.RESPONSE
                  new Vue.prototype.$Dialog({
                    title: '温馨提示',
                    text: RETURN_DESC,
                    onOk() {
                      crh.closeWebApp()
                      return
                    }
                  })
                  Modal.error({
                    title: '温馨提示',
                    content: RETURN_DESC,
                    onOk() {
                      crh.closeWebApp()
                      return
                    }
                  })
                }
                // 返回网络类型, 有效值：
                // wifi/2g/3g/4g/unknown(Android下不常见的网络类型)/none(无网络)
              },
              fail: function(res) {
                // alert('2-'+ res.networkType)
              },
              complete: function(res) {
                // crh.closeWebApp();
              }
            })
            reject(err)
          }
        })
      })
    }
  }
  ssdpReady() {
    if (this.ready) {
      return Promise.resolve()
    } else if (!!this.error) {
      return Promise.reject(this.error)
    }
    return new Promise((resolve, reject) => {
      let count = 0
      let job = setInterval(() => {
        if (this.ready || count >= 15) {
          clearInterval(job)
          this.ready ? resolve() : reject('初始化超时')
        }
        count++
      }, 200)
    })
  }
  async init() {
    if (this.ready || process.env.NODE_ENV !== 'development') {
      this.ready = true
      await Promise.resolve()
    }

    let [sys, app] = await this.getBaseInfoByNative()

    SSDPHelp.User_Token = app.external_token
    this.SSDPHelp = new SSDPHelp({
      //应用编码
      App_Sub_ID: app.App_Sub_ID,
      //授权令牌
      App_Token: app.App_Token,
      //签名秘钥
      App_key: app.App_key,
      App_Version: sys.appVersion,
      App_ID: 'VTest',
      //组织编码
      Partner_ID: app.Partner_ID,
      Divice_ID: sys.deviceID,
      Divice_Version: sys.system,
      OS_Version: sys.platform
    })
    await this.SSDPHelp.init()
    this.ready = true
  }
  async getBaseInfoByNative() {
    if (process.env.NODE_ENV === 'development') {
      let res = await import('../../local.ssdp.mock.js')
      let { sys, app } = res.default
      return [sys, app]
    }
    return []
  }
}

export default Request
